/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_EntityInputs */

const cs_import_entity = /** @type {(inputs: Import_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entita`)
};

const en_import_entity = /** @type {(inputs: Import_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity`)
};

/**
* | output |
* | --- |
* | "Entity" |
*
* @param {Import_EntityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_entity = /** @type {((inputs?: Import_EntityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_EntityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_entity(inputs)
	return cs_import_entity(inputs)
});